import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Modal, Stack, Toolbar, Typography, useTheme } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';

function PvAppModal({ open, handleClose, children, toolBarContent }) {
    const { palette } = useTheme()
    return (
        <Dialog sx={{ padding: 0, margin: 0 }} fullScreen open={open} onClose={handleClose}>
            {/* <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Stack flex={1}>
                        {toolBarContent}
                    </Stack>
                    <Button autoFocus color={'error'} onClick={handleClose}>
                        Close
                    </Button>
                </Toolbar>
            </AppBar> */}
            <DialogContent sx={{ p: 0, m: 0 }}>
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default PvAppModal
